import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { AppState } from 'src/app/store/app.reducer';
import { ActivatedRoute } from '@angular/router';
import { InvitationData } from 'src/app/model/api/invitation-data';
import * as HomeActions from 'src/app/store/home/home.actions';
import * as UserActions from 'src/app/store/user/user.actions';
import { selectSupportTabIndex } from 'src/app/store/home/home.selector';
import * as NotificationsActions from "../../../../store/notifications/notifications.actions";
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { selectTopbarTitle } from 'src/app/store/notifications/notifications.selector';
import * as AnalyticsActions from 'src/app/store/analytics/analytics.actions';

@Component({
	selector: 'app-support-user',
	templateUrl: './support-user.component.html',
	providers: [],
	styles: [`
		:host ::ng-deep .transparent-tabView .p-tabview-panels {
			background: transparent !important;
			padding-left: 0px;
			padding-right: 0px;
		}
	`]
})

export class SupportComponent implements OnInit, OnDestroy{
	// Observables and subscriptions
	supportTabIndex$: Observable<number | undefined>;
	supportTabIndexSub: Subscription | undefined;

	supportTabIndex: number;

	tabIndex$: Observable<number>;

	titleSel$: Observable<string>;
	titleSub: Subscription | undefined;
	titleId = '';

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private route: ActivatedRoute,
	) {
		this.initSelectors();
		this.onResize();
	}

	ngOnInit(): void {
		this.store.dispatch(NotificationsActions.setTopbarTitleId({
			stringId: 'SUPPORT_REQUESTS'
		}));
		this.subscribeAll();
		const invitationData = this.route.snapshot.queryParams['invitationData'];
		if (invitationData) {
				const decodedData: InvitationData = JSON.parse(atob(invitationData));
				this.store.dispatch(UserActions.assignTechnicianToUser({
						technicianId: decodedData.TechnicianId,
						verification: decodedData.Verification,
				}));
		}
		this.onResize();

		this.catchAnalytics();
	}

	ngOnDestroy(): void {
		this.supportTabIndexSub?.unsubscribe();
		this.titleSub?.unsubscribe();
	}

	initSelectors(): void{
		// Store selectors
		this.supportTabIndex$ = this.store.select(selectSupportTabIndex);
		this.titleSel$ = this.store.select(selectTopbarTitle);
	}

	subscribeAll(): void {
		this.supportTabIndexSub = this.supportTabIndex$?.subscribe(
			(supportTabIndex: number) => {
				this.supportTabIndex = supportTabIndex;
			}
		);
		this.titleSub = this.titleSel$.subscribe(
			(title: string) => {
				this.titleId = title;
			}
		);
	}

	changeTab(e) {
		this.store.dispatch(HomeActions.selectSupportTab({ index: e.index }));
		this.catchAnalytics();
	}

	catchAnalytics() {
		switch (this.supportTabIndex) {
			case 1:
				setTimeout(() => {
					this.store.dispatch(AnalyticsActions.eventCustomPageView({ params: { page_title: 'Technicians list' } }));
				}, 1000);
				break;
			default:
				setTimeout(() => {
					this.store.dispatch(AnalyticsActions.eventCustomPageView({ params: { page_title: 'Support requests (USER)' } }));
				}, 1000);
				break;
		}
	}

	// Design
	@HostListener('window:resize')
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile() {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	layoutMarginResponsive(): string {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}
}
